
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45PND9H2Sr25hj01N0N8NTJPZ6eHR7Fj77bF620JYWFYMeta } from "/home/ploi/rewards.flights/pages/index.vue?macro=true";
import { default as contact530k4ofV2AF18HWSsInmCA_45vI6yblxdIwMolMYckgI0Meta } from "/home/ploi/rewards.flights/pages/contact.vue?macro=true";
import { default as indexJLkdEmJcWajrJMq4dMuFU0cdXFvKQmIi4ovZshYm8BMMeta } from "/home/ploi/rewards.flights/pages/nl/index.vue?macro=true";
import { default as extensionrsEIyB7Ib4FIKRgAvA_AnlPiSliear_45HlLzqTL9A854Meta } from "/home/ploi/rewards.flights/pages/extension.vue?macro=true";
import { default as indexyd0u7DA4_yD98_zmukCbxCt0ExtPrWH1zDiWmOOHCigMeta } from "/home/ploi/rewards.flights/pages/blog/index.vue?macro=true";
import { default as index9tIoVW8y51XCqzVpIoMmOgDHd_45VZMK2HnYXJgmJwM5wMeta } from "/home/ploi/rewards.flights/pages/nl/blog/index.vue?macro=true";
import { default as index_45C_45pgPL_45OCD0i_45v0hh6Ph9SFiV7zadQNh2y2vo_XP7sMeta } from "/home/ploi/rewards.flights/pages/airlines/index.vue?macro=true";
import { default as _91_46_46_46slug_938MbC3d3A3z3V4cEquVQGfKLLiXj16FOV3xQ0_45iiMDnQMeta } from "/home/ploi/rewards.flights/pages/blog/[...slug].vue?macro=true";
import { default as privacy_45policyn55hCKpjXtPMsMW3pcB7BRTt0vSU3WSjUVxmav86UjcMeta } from "/home/ploi/rewards.flights/pages/privacy-policy.vue?macro=true";
import { default as terms_45of_45service1seBA4ZWB3F4QDwJU0PzMmSbNwTJW7NXpV92Gs0dCvkMeta } from "/home/ploi/rewards.flights/pages/terms-of-service.vue?macro=true";
import { default as _91_46_46_46slug_93J8G4AOwW47m6cTW9CEpjOcu1uF8oQ7vMryDZNipKH9gMeta } from "/home/ploi/rewards.flights/pages/flights/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93xQyZYiubvl7T6JAzgrbZLVydo7_Sd_A04_45OsYqrZ2ScMeta } from "/home/ploi/rewards.flights/pages/lounges/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93P9_45LDmnNbn_45hF220egYk69UozY_45KgwOljBesNsE5gK8Meta } from "/home/ploi/rewards.flights/pages/nl/blog/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93RSgZ34ilUBL3fMAapuQTZnCnsza4A9ktnLrWfpkKk2AMeta } from "/home/ploi/rewards.flights/pages/airlines/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93PRo_45udbcVKtfevzcreGZx1nXJIwigbqoP2P81sLBU80Meta } from "/home/ploi/rewards.flights/pages/aircrafts/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93p_45ikceuxcSxbroA1dizbnluWQYCOUa_U3Fa2PmqZcN8Meta } from "/home/ploi/rewards.flights/pages/nl/lounges/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_934fDOwQ_45XUudx0P2v0_csutIj60aDbX0xIGoZxJgWEI8Meta } from "/home/ploi/rewards.flights/pages/nl/vluchten/[...slug].vue?macro=true";
import { default as flights_45to_45_91name_93_45_91iata_93cjItf7mx1J_45w7i6gjFuVo36zGJxfakous_YnPGYlJKgMeta } from "/home/ploi/rewards.flights/pages/flights-to-[name]-[iata].vue?macro=true";
import { default as _91_46_46_46slug_93Wuk88roFC2qNxO1t9FFvegUVWWklBG8QG4oJNvER00YMeta } from "/home/ploi/rewards.flights/pages/nl/vliegtuigen/[...slug].vue?macro=true";
import { default as flights_45from_45_91name_93_45_91iata_93_EHRcNgM6GOy_45oEOEDBUAESapkt0fqJ9DfzDCvTl7kcMeta } from "/home/ploi/rewards.flights/pages/flights-from-[name]-[iata].vue?macro=true";
import { default as vluchten_45naar_45_91name_93_45_91iata_937eDgOpzOztYWisjg189q876rmJxWaU3FwBAlvmEcYqwMeta } from "/home/ploi/rewards.flights/pages/nl/vluchten-naar-[name]-[iata].vue?macro=true";
import { default as vluchten_45vanaf_45_91name_93_45_91iata_93H3Z50vrvH1T5Ytdyt_VuRlGeScCyZGVQ_45EpOyUtz2u0Meta } from "/home/ploi/rewards.flights/pages/nl/vluchten-vanaf-[name]-[iata].vue?macro=true";
import { default as index_7O_n7LMAzOmqqbq4Y0q74dTyZRLkMBgvU6B3IGnPfoMeta } from "/home/ploi/rewards.flights/pages/nl/luchtvaartmaatschappijen/index.vue?macro=true";
import { default as _91_46_46_46slug_939nA134veaUjsHEhd_Hx1ojB71fnG84YyPlUml73gpc4Meta } from "/home/ploi/rewards.flights/pages/nl/luchtvaartmaatschappijen/[...slug].vue?macro=true";
import { default as flights_45from_45_91name_93_45_91iata_93_45to_45_91to_45name_93_45_91to_45iata_93Iydh14lLhB3M1KPaQ74t8vw18_k6wUZ1pLzArtqcRNAMeta } from "/home/ploi/rewards.flights/pages/flights-from-[name]-[iata]-to-[to-name]-[to-iata].vue?macro=true";
import { default as vluchten_45vanaf_45_91name_93_45_91iata_93_45naar_45_91to_45name_93_45_91to_45iata_93_EWDRZ0WJY0j8jG8q1Xt6wsEo8C8aaffqcVUGU9WAxoMeta } from "/home/ploi/rewards.flights/pages/nl/vluchten-vanaf-[name]-[iata]-naar-[to-name]-[to-iata].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/ploi/rewards.flights/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact530k4ofV2AF18HWSsInmCA_45vI6yblxdIwMolMYckgI0Meta || {},
    component: () => import("/home/ploi/rewards.flights/pages/contact.vue")
  },
  {
    name: "nl",
    path: "/nl",
    component: () => import("/home/ploi/rewards.flights/pages/nl/index.vue")
  },
  {
    name: "extension",
    path: "/extension",
    meta: extensionrsEIyB7Ib4FIKRgAvA_AnlPiSliear_45HlLzqTL9A854Meta || {},
    component: () => import("/home/ploi/rewards.flights/pages/extension.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/ploi/rewards.flights/pages/blog/index.vue")
  },
  {
    name: "nl-blog",
    path: "/nl/blog",
    component: () => import("/home/ploi/rewards.flights/pages/nl/blog/index.vue")
  },
  {
    name: "airlines",
    path: "/airlines",
    component: () => import("/home/ploi/rewards.flights/pages/airlines/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/blog/[...slug].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/ploi/rewards.flights/pages/privacy-policy.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/home/ploi/rewards.flights/pages/terms-of-service.vue")
  },
  {
    name: "flights-slug",
    path: "/flights/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/flights/[...slug].vue")
  },
  {
    name: "lounges-slug",
    path: "/lounges/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/lounges/[...slug].vue")
  },
  {
    name: "nl-blog-slug",
    path: "/nl/blog/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/nl/blog/[...slug].vue")
  },
  {
    name: "airlines-slug",
    path: "/airlines/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/airlines/[...slug].vue")
  },
  {
    name: "aircrafts-slug",
    path: "/aircrafts/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/aircrafts/[...slug].vue")
  },
  {
    name: "nl-lounges-slug",
    path: "/nl/lounges/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/nl/lounges/[...slug].vue")
  },
  {
    name: "nl-vluchten-slug",
    path: "/nl/vluchten/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/nl/vluchten/[...slug].vue")
  },
  {
    name: "flights-to",
    path: "/flights-to-:name()-:iata()",
    meta: flights_45to_45_91name_93_45_91iata_93cjItf7mx1J_45w7i6gjFuVo36zGJxfakous_YnPGYlJKgMeta || {},
    component: () => import("/home/ploi/rewards.flights/pages/flights-to-[name]-[iata].vue")
  },
  {
    name: "nl-vliegtuigen-slug",
    path: "/nl/vliegtuigen/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/nl/vliegtuigen/[...slug].vue")
  },
  {
    name: "flights-from",
    path: "/flights-from-:name()-:iata()",
    meta: flights_45from_45_91name_93_45_91iata_93_EHRcNgM6GOy_45oEOEDBUAESapkt0fqJ9DfzDCvTl7kcMeta || {},
    component: () => import("/home/ploi/rewards.flights/pages/flights-from-[name]-[iata].vue")
  },
  {
    name: "vluchten-naar",
    path: "/nl/vluchten-naar-:name()-:iata()",
    meta: vluchten_45naar_45_91name_93_45_91iata_937eDgOpzOztYWisjg189q876rmJxWaU3FwBAlvmEcYqwMeta || {},
    component: () => import("/home/ploi/rewards.flights/pages/nl/vluchten-naar-[name]-[iata].vue")
  },
  {
    name: "vluchten-vanaf",
    path: "/nl/vluchten-vanaf-:name()-:iata()",
    meta: vluchten_45vanaf_45_91name_93_45_91iata_93H3Z50vrvH1T5Ytdyt_VuRlGeScCyZGVQ_45EpOyUtz2u0Meta || {},
    component: () => import("/home/ploi/rewards.flights/pages/nl/vluchten-vanaf-[name]-[iata].vue")
  },
  {
    name: "nl-luchtvaartmaatschappijen",
    path: "/nl/luchtvaartmaatschappijen",
    component: () => import("/home/ploi/rewards.flights/pages/nl/luchtvaartmaatschappijen/index.vue")
  },
  {
    name: "nl-luchtvaartmaatschappijen-slug",
    path: "/nl/luchtvaartmaatschappijen/:slug(.*)*",
    component: () => import("/home/ploi/rewards.flights/pages/nl/luchtvaartmaatschappijen/[...slug].vue")
  },
  {
    name: "flights-between",
    path: "/flights-from-:name()-:iata()-to-:toname()-:toiata()",
    meta: flights_45from_45_91name_93_45_91iata_93_45to_45_91to_45name_93_45_91to_45iata_93Iydh14lLhB3M1KPaQ74t8vw18_k6wUZ1pLzArtqcRNAMeta || {},
    component: () => import("/home/ploi/rewards.flights/pages/flights-from-[name]-[iata]-to-[to-name]-[to-iata].vue")
  },
  {
    name: "vluchten-tussen",
    path: "/nl/vluchten-vanaf-:name()-:iata()-naar-:toname()-:toiata()",
    meta: vluchten_45vanaf_45_91name_93_45_91iata_93_45naar_45_91to_45name_93_45_91to_45iata_93_EWDRZ0WJY0j8jG8q1Xt6wsEo8C8aaffqcVUGU9WAxoMeta || {},
    component: () => import("/home/ploi/rewards.flights/pages/nl/vluchten-vanaf-[name]-[iata]-naar-[to-name]-[to-iata].vue")
  }
]